import React from 'react';
import PropTypes from 'prop-types';

import StatsSection from './StatsSection';
import TestimonialsSection from './TestimonialsSection';
import LogoStrip from './LogoStrip';

import styles from './styles.module.scss';

const StatsTestimonials = ({
  title = null,
  description = null,
  stats = null,
  testimonialsTitle = null,
  testimonials = null,
  logos = null,
  buttonLabel = null,
  buttonLink = null,
}) => (
  <div className={styles.container}>
    <div className="container">
      <StatsSection title={title} description={description} stats={stats} />
      <div className={styles.testimonialsWrapper}>
        <TestimonialsSection
          testimonialsTitle={testimonialsTitle}
          testimonials={testimonials}
          buttonLabel={buttonLabel}
          buttonLink={buttonLink}
        />
        <LogoStrip logos={logos} />
      </div>
    </div>
  </div>
);


StatsTestimonials.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ),
  testimonialsTitle: PropTypes.string,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      authorName: PropTypes.string.isRequired,
      authorTitle: PropTypes.string.isRequired,
      authorPhoto: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
      }),
    })
  ),
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.string,
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string,
      sizes: PropTypes.shape({
        thumbnail: PropTypes.shape({
          url: PropTypes.string,
        }),
        medium: PropTypes.shape({
          url: PropTypes.string,
        }),
        large: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    })
  ),
};

export default StatsTestimonials;
